import { OidcSecure, useReactOidc } from '@axa-fr/react-oidc-context';
import { ConfigProvider } from 'antd/lib';
import React, { Fragment, memo, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import CircularProgress from '../../components/CircularProgress';
// import { ISigninModel } from "../../interfaces";
import { ThemeSetting } from '../../constants/ThemeSetting';
import ChatContext from '../../contexts/ChatContext';
import { AppLocale } from '../../lngProvider';
import ErrorPage from '../../routes/auth/ErrorPage';
import AuthMiddleware from './AuthMiddleware';

const {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
} = ThemeSetting;

const NotFound = (props: any) => {
  if (props.match.path !== '/') return <Redirect to={'/team-work/home'} />;
  return <Fragment />;
};

const LoginHandler = (isprocess: any) => {
  const { oidcUser } = useReactOidc() as any;
  const history = useHistory();

  useEffect(() => {
    if (oidcUser) {
      if (isprocess.isprocess === true) {
        return history.push('/process');
      }
      else {
        return history.push('/');
      }
    }
  }, []);
  return (
    <div className="gx-main-content-wrapper">
      <CircularProgress className="" />
    </div>
  );
};

const App: React.FC = () => {
  const dispatch = useDispatch();

  const { locale, navStyle, layoutType, pathname } = useSelector(
    ({ settings }: any) => settings,
  );
  // const { initURL } = useSelector(({ auth }: any) => auth);

  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();


  const setLayoutType = (layoutType: string) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  const setNavStyle = (navStyle: any) => {
    if (
      navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER
    ) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };


  if (
    location.pathname === '/' ||
    location.pathname === '/process' ||
    location.pathname === '/home' ||
    location.pathname === '/team-work' ||
    location.pathname === '/index.html'
  ) {
    if (window.config.replaceInstancePageByHomePage && location.pathname !== '/process') {
      history.push('/team-work/instance?folder=Inbox-0');
      return <Fragment />;
    } else if (location.pathname === '/process') {
      history.push('/team-work/instance?folder=Process-0');
      return <Fragment />;
    }
    history.push('/team-work/home');
    return <Fragment />;
  }

  const currentAppLocale = AppLocale[locale.locale];
  const errorHandler = (e: any) => {
    console.log(e.message, e.code);
  };
  return (
    <ConfigProvider
      locale={currentAppLocale.antd}
      direction={currentAppLocale.direction}
    >
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
        onError={errorHandler}
      >
        {/* <Router basename={process.env.PUBLIC_URL}> */}
        <Switch>
          <Route path={`/init-login`}>
            <OidcSecure>
              <LoginHandler isprocess={false} />
            </OidcSecure>
          </Route>
          <Route path={`/init-login-process`}>
            <OidcSecure>
              <LoginHandler isprocess={true} />
            </OidcSecure>
          </Route>
          <Route path={`${match.url}`}>
            <ChatContext>
              <AuthMiddleware />
            </ChatContext>
          </Route>

          <Route
            exact
            path="/error/:errorCode?"
            render={(props) => <ErrorPage {...props} />}
          />

          <Route component={NotFound} />
        </Switch>
        {/* </Router> */}
      </IntlProvider>
    </ConfigProvider>
  );
};

export default memo(App);
